<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-12">
          <div class="w-100">
            <h1>Latar Belakang</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mt-4 mx-1 mx-md-3">
        <div class="col-12 text-left my-2 px-0 px-md-4">
          <p>
            SEJARAH radio di Malaysia bermula pada 1921 apabila Al Birch,
            seorang jurutera elektrik kerajaan Johor membawa set radio pertama
            ke negara ini.Beliau kemudiannya menubuhkan Persatuan Wireless Johor
            yang memulakan siarannya melalui gelombang 300 meter. Beliau
            kemudian menubuhkan persatuan serupa di Pulau Pinang dan Persatuan
            Wireless Malaysia di Kuala Lumpur.
          </p>
          <p>
            Pada 1930, Sir Earl daripada Lembaga Pelabuhan Singapura melancarkan
            siaran gelombang pendek setiap dua minggu sama ada pada hari Ahad
            atau Rabu. Usaha itu kemudian diteruskan oleh Persatuan Wireless
            Malaysia, yang melancarkan siarannya dari Bukit Petaling, Kuala
            Lumpur melalui gelombang 325 meter. Ini diikuti usaha Sir Shenton
            Thomas yang membuka Studio Perbadanan Penyiaran British dengan
            menggunakan pemancarnya di Caldecott Hill, Singapura pada 11 Mac
            1937. Seterusnya Perbadanan Penyiaran British Malaya diambil alih
            oleh Negeri-Negeri Selat dan menjadi sebahagian daripada Kementerian
            Penerangan British yang lebih dikenali dengan nama Perbadanan
            Penyiaran Malaya.
          </p>
          <p>
            Pada 1942, berikutan pendudukan Jepun di Tanah Melayu dan tamatnya
            era pemerintahan Britian di Singapura, Jepun telah mengambil alih
            saluran radio sedia ada dan memperkenalkan saluran radio di Pulau
            Pinang, Melaka, Kuala Lumpur, Seremban dan Singapura untuk
            menyiarkan propaganda mereka. Bagaimanapun, pada 1943, British
            kembali berkuasa dan mengambil allih semula stesen-stesen radio
            tersebut.
          </p>
          <p>
            Pada 1 April 1946, Jabatan Penyiaran ditubuhkan di Singapura.
            Pembangunan perkhidmatan radio dilihat bertambah penting apabila
            darurat diisytiharkan pada 1948. Pada awal 1950-an, penyiaran di
            Malaya beroperasi sementara di Jalan Young, Kuala Lumpur (kini
            dikenali Jalan Cenderasari ) dan pada 1956 pula berpindah ke Rumah
            Persekutuan Kuala Lumpur. Di sini, bidang penyiaran di Malaysia
            berkembang dan beberapa stesen radio kemudian diwujudkan di seluruh
            Malaysia termasuk di Sabah dan Sarawak.
          </p>
          <p>
            Pada tahun 1960, buat pertama kalinya iklan komersial disiarkan di
            radio dan ia menjadi sumber pendapatan baharu kerajaan. Ketika
            Malaysia dibentuk pada 16 September 1963, juruhebah bertugas
            menggunakan “INILAH RADIO MALAYSIA” dijadikan pengenalan oleh
            juruhebah bertugas ketika . Bidang penyiaran membuka satu lagi
            lembaran dengan Angkasapuri yang memulakan siarannya pada 6 Oktober
            1969.
          </p>
          <p>
            Radio dan televisyen kemudian bergabung di bawah Kementerian
            Penerangan. Pertumbuhan saluran pertama, Rangkaian Satu,
            mengggalakkan pembentukan saluran kedua pada 17 November 1969. Di
            Kompleks Angkasapuri, pembangunan pesat berlaku di bidang penyiaran
            sama ada radio atau televisyen. Rangkaian radio nasional bermula 24
            jam untuk memberi perkhidmatan kepada semua golongan
            pendengar,terutama yang bekerja malam.
          </p>
          <p>
            Media elektronik adalah sumber penting menerima dan menyebarkan
            maklumat kerana ia pantas, murah dan dapat disampaikan secara
            langsung kepada pendengar. Oleh itu, RTM berpendapat wajar untuk
            meletakkan usaha menyampaikan maklumat dan pada masa sama memberi
            hiburan digabungkan. Atas kesedaran itu, maka pada 20 Jun 1975,
            lahirlah Radio Muzik. Industri penyiaran Malaysia terus bergerak
            pantas seiring dengan perkembangan teknologi. RTM yang pada
            peringkat awalnya memancarkan beberapa stesen kini mempunyai 34
            stesen radio.
          </p>
          <p>
            Perkembangan Media baharu memberi impak yang besar kepada penyebaran
            maklumat kepada khalayak. Menyedari hakikat ini RTM mengorak langkah
            dengan memperkenalkan web streaming TV dan Radio seawal tahun 1996
            lagi. Mulai tahun 2012 perkhidmatan ini diperluaskan dengan
            penggunaan mobile streaming. Sehingga 2013, RTM mempunyai 3 stesen
            TV (TV1, TV2, TVi dan Galaksi Muzik) dan 34 stesen Radio yang boleh
            ditonton dan didengar melalui web dan Mobile streaming (RTM Mobile).
          </p>
          <p>
            Kini RTM mengorak langkah maju ke hadapan selari dengan perkembangan
            teknologi semasa dengan menampilkan 6 stesen TV (TV1, TV2, TV Okey,
            Berita RTM, Sukan RTM dan TV6) dan 34 stesen Radio yang boleh
            ditonton dan didengar melalui web dan Aplikasi RTMKlik.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {};
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 20px 0 0;
  min-height: 80vh;
}

h1 {
  font-family: Inter;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: #dae12f;
}
p {
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #fff;
  font-family: Inter;
}
</style>
